<template>
  <div class="h-auto bg-white w-full">
    <div class="all">
      <!-- Si showDetails est faux, on montre la liste -->
      <div v-if="!showDetails">
        <div
          v-for="(item, index) in allStat"
          :key="index"
          class="w-full flex items-center text-c14 2xl:text-c16 font-c4 text-left mb-6 diviser px-3 rounded-t-14 hover:bg-gray-100"
        >
          <div class="w-1/3 flex items-center gap-3 font-c5 text-c15 2xl:text-c20 text-black">
            <div class="">
              <icon
                :data="icons.IconFececamBenin"
                height="46"
                width="46"
                class="w-5 h-5"
                original
              />
            </div>

            {{ item.sfd.name }}
          </div>

          <div class="w-1/4 ml-4 text-titre">
            {{ item.admin.email }}
          </div>

          <div class="w-1/5 ml-4">
            {{ item.totalCommerce }}
          </div>

          <div class="w-1/4 ml-4">
            {{ item.value2 }} ----------
          </div>

          <div class="w-1/4 ml-4 text-center">
            {{ item.admin.firstName }} {{ item.admin.lastName }}
          </div>
        </div>
      </div>

      <!-- Sinon on montre le composant de détails -->
      <div v-else>
        <detailsPartners :partner="selectedItem" />
      </div>
    </div>
  </div>
</template>

<script>
import user from '../../../assets/icons/ic-clientAv.svg'
import entreprise from '../../../assets/icons/ic-entreprise.svg'
import IconFececamBenin from '../../../assets/icons/ic-fececamBenin.svg'
import detailsPartners from './deailsPartners.vue' // attention au nom du fichier ici
import apiroutes from '../../../router/api-routes'
import http from '../../../plugins/https'
import store from '../../../store'

export default {
  name: "Index",
  components: {
    detailsPartners,
  },
  icons: {
    IconFececamBenin
      },

  props: {
    flow: {
      type: Object,
      default: null
    }
  },

  data() {
    return {
      allStat: null,
      showDetails: false,
      selectedItem: null,
      icons: {
        user,
        entreprise,
        IconFececamBenin,
      },
    };
  },

  created () {
    this.getBillan()
  },

  methods: {
  selectItem(item) {
    this.$emit('partnerSelected', item); // ← on envoie l'item sélectionné
  },
  getBillan () {
      http.defaults.headers.common.Authorization = 'Bearer ' + store.getters.token
      http.get(apiroutes.baseURL + apiroutes.allSfd)
          .then(response => {
            this.allStat = response
            // console.log('sfd')
            console.log(response)
            this.charge = false
          })
          .catch(error => {
            this.charge = false
            // console.log(error)
          })
    }
  },
};
</script>

<style lang="scss" scoped>
.svg-icon {
  fill: transparent;
}
.item:hover {
  border-left: 3px groove black;
  padding-left: 30px;
}
</style>
